import posthog from 'posthog-js'

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://eu.i.posthog.com'

let initialized = false

export function initPostHog() {
  if (initialized || !KEY) return
  posthog.init(KEY, {
    api_host: HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: false,
    autocapture: false,
    session_recording: {
      maskTextSelector: '.ph-no-capture',
      maskAllInputs: true,
    },
  })
  initialized = true
}

export function optIn() {
  if (!initialized) return
  posthog.opt_in_capturing()
}

export function optOut() {
  if (!initialized) return
  posthog.opt_out_capturing()
}

export function hasOptedIn(): boolean {
  if (!initialized) return false
  return posthog.has_opted_in_capturing()
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return
  posthog.capture(event, properties)
}
